import type {
  CustomActionButtonToAdd,
  CustomActionButtonToEdit,
  ExecuteCustomActionButtonResponse,
  GetCustomActionButtonsResult,
  GetUserCustomActionButtonsResult
} from 'api/models/mainservice';
import { protectedApiClient } from 'api/support/baseApiClients';

export default {
  getCustomActionButtons: async () => {
    const result = await protectedApiClient.get<GetCustomActionButtonsResult>(
      `/Integration/customActionButtons`
    );
    return result.data;
  },
  getUserCustomActionButtons: async () => {
    const result = await protectedApiClient.get<GetUserCustomActionButtonsResult>(
      `/Integration/customActionButtons/user`
    );
    return result.data;
  },
  addCustomActionButton: async (data: CustomActionButtonToAdd) => {
    const result = await protectedApiClient.post<undefined>(
      `/Integration/customActionButton`,
      data
    );
    return result.data;
  },
  executeCustomActionButton: async (id: string, isTest?: boolean) => {
    const result = await protectedApiClient.post<ExecuteCustomActionButtonResponse>(
      `/Integration/customActionButton/${id}/execute`,
      undefined,
      { params: { isTest } }
    );

    return result.data;
  },
  executeCustomActionButtonOnEntity: async (params: { id: string; entityId: string }) => {
    const result = await protectedApiClient.post<ExecuteCustomActionButtonResponse>(
      `/Integration/customActionButton/${params.id}/execute/${params.entityId}`
    );
    return result.data;
  },
  editCustomActionButton: async (params: { id: string; data: CustomActionButtonToEdit }) => {
    const result = await protectedApiClient.put<undefined>(
      `/Integration/customActionButton/${params.id}`,
      params.data
    );
    return result.data;
  },
  deleteCustomActionButton: async (id: string) => {
    const result = await protectedApiClient.delete<undefined>(
      `/Integration/customActionButton/${id}`
    );
    return result.data;
  }
};
